<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import useDevicesTable from "@/scripts/Courses/DevicesTable.js";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const store = useStore();
const course = computed(() => store.getters["course/getCourse"]);

const {
  columns,
  tableData,
  tableOptions,
  handleSearch,
  handleSortChange,
  onSelect,
  onDeselect,
  handleLengthChange,
  onPageChange,
  sendLogsCommand,
  sendConfigCommand,
  sendCoursesCommand,
  sendAdvertisementsCommand,
} = useDevicesTable(course.value.id);
</script>

<template>
  <div class="table-responsive">
    <div class="card-body">
      <div class="mb-3">
        <button @click="sendLogsCommand" class="btn btn-secondary">
          Get Logs
        </button>
        <button @click="sendConfigCommand" class="btn btn-secondary">
          Get Config
        </button>
        <button @click="sendCoursesCommand" class="btn btn-secondary">
          Get Courses
        </button>
        <button @click="sendAdvertisementsCommand" class="btn btn-secondary">
          Get Advertisements
        </button>
      </div>
      <DataTable
        :data="tableData"
        :columns="columns"
        :options="tableOptions"
        @page="onPageChange"
        @select="(event, dt, type) => onSelect({ event, dt, type })"
        @deselect="(event, dt, type) => onDeselect({ event, dt, type })"
        @length="(event, dt) => handleLengthChange({ event, dt })"
        @search="(event, dt) => handleSearch({ event, dt })"
        @order="(event, dt) => handleSortChange({ event, dt })"
        class="table table-hover table-bordered table-spacing"
        width="100%"
      >
      </DataTable>
    </div>
  </div>
</template>

<style>
.table-responsive {
  overflow-x: auto;
}
.table-spacing {
  margin: 5px 0 !important;
}
</style>
